import { render, staticRenderFns } from "./TechnicalInputs.vue?vue&type=template&id=73ccb996&scoped=true&lang=pug&"
import script from "./TechnicalInputs.vue?vue&type=script&lang=js&"
export * from "./TechnicalInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ccb996",
  null
  
)

export default component.exports